import axios from "axios"

export default {
  getAdAccountAds(adAccountId, query) {
    const url = `/fam/adaccounts/${adAccountId}/ads`

    return axios.get(url, { params: query }).then(response => {
      return response.data
    })
  },

  getAdDraft(id) {
    const url = `/fam/ads-drafts/${id}`

    return axios.get(url).then(response => {
      return response.data
    })
  },

  postAdDraft(data) {
    const url = `/fam/ads-drafts`

    return axios.post(url, data).then(response => {
      return response.data
    })
  },

  patchAdDraft(id, data) {
    const url = `/fam/ads-drafts/${id}`

    return axios.patch(url, data).then(response => {
      return response.data
    })
  },

  patchAdStatus(adId) {
    const url = `/fam/ads/${adId}/status`

    return axios.patch(url, {}).then(response => {
      return response.data
    })
  },

  publishAdDraft(id) {
    const url = `/fam/ads-drafts/${id}/publish`

    return axios.post(url, {}).then(response => {
      return response.data
    })
  },
}
